<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="createVenueHireDetails" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{ item.floor_id }}</td>
              <td>{{ item.venue_hire ? item.venue_hire.name_th : "" }}</td>
              <td>{{ item.name_th }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>
                <a @click="showVenueHireDetailsData(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import IconPencil from "../../../components/Icon/icon-pencil";
import CircleButton from "../../../components/Button/CircleButton";
import InputTextField from "../../../components/Input/InputTextField";
import InputSearch from "../../../components/Input/InputSearch";
import Paginate from "../../../components/Layout/Paginate";
export default {
  name: "VenueHireDetailsTable",
  components: {Paginate, InputSearch, InputTextField, CircleButton, IconPencil },
  data() {
    return {
      title: "Venue hire detail",
      headers: [
        { id: 1, text: "No." },
        { id: 2, text: "Floor" },
        { id: 3, text: "Venue hire" },
        { id: 4, text: "Venue hire detail" },
        { id: 5, text: "Update date" },
        { id: 6, text: "edit" }
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      }
    };
  },
  created() {
    this.getVenueHireDetailsTable(1);
  },
  methods: {
    goToVenueHireDetailsEdit() {
      this.$router.push("/venue-hire-details/edit");
    },
    getVenueHireDetailsTable(page) {
      this.$store.dispatch("VenueHireDetails/getVenueHireDetails", page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    changePage(val){
      this.dataPaginate.current_page = val;
      this.$store.dispatch("VenueHireDetails/getVenueHireDetails", this.dataPaginate.current_page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    showVenueHireDetailsData(id) {
      this.$store.dispatch("VenueHireDetails/showVenueHireDetails", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("VenueHireDetails/setFormVenueHireDetails", res.result).then(() => {
            this.goToVenueHireDetailsEdit();
          });
        } else {
          alert(res.response_msg);
        }
      });
    },
    createVenueHireDetails() {
      this.$store.dispatch("VenueHireDetails/clearFormData").then(() => {
        this.goToVenueHireDetailsEdit();
      });
    },

  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/table.css";
@import "../../../assets/css/variables";
.branch-data {
  background-color: $background-theme;
  margin: 20px;
}
</style>
